import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/index/Index'
import IndexHome from '@/components/index/Home'

import Detect from '@/components/detect/Detect'

import OrderCreate from '@/components/order/Create'
import OrderList from '@/components/order/List'
import OrderComplete from '@/components/order/Complete'
import OrderPrice from '@/components/order/Price'

import ReportEdit from '@/components/report/Edit'
import ReportReport from '@/components/report/Report'
import ReportExport from '@/components/report/Export'

import UserEdit from '@/components/user/Edit'
import UserLogin from '@/components/user/Login'
import UserRegister from '@/components/user/Register'
import UserBind from '@/components/user/Bind'

import ForgetPassword from '../components/user/ForgetPassword'
import ResetPassword from '../components/user/ResetPassword'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'Index',
            component: Index,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/home',
            name: 'IndexHome',
            component: IndexHome,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/detect/',
            name: 'Detect',
            component: Detect,
            meta: {
                title: '检测单'
            }
        },
        {
            path: '/order/create',
            name: 'OrderCreate',
            component: OrderCreate,
            meta: {
                title: '发起预约单'
            }
        },
        {
            path: '/order/List',
            name: 'OrderList',
            component: OrderList,
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/order/complete',
            name: 'OrderComplete',
            component: OrderComplete,
            meta: {
                title: '完善订单信息'
            }
        },
        {
            path: '/order/price',
            name: 'OrderPrice',
            component: OrderPrice,
            meta: {
                title: '评估检测价格'
            }
        },
        {
            path: '/report/edit',
            name: 'ReportEdit',
            component: ReportEdit,
            meta: {
                title: '检测报告修改'
            }
        },
        {
            path: '/report/export',
            name: 'ReportExport',
            component: ReportExport,
            meta: {
                title: '检测报告预览'
            }
        },
        {
            path: '/report/report',
            name: 'ReportReport',
            component: ReportReport,
            meta: {
                title: '检测报告'
            }
        },
        {
            path: '/user/edit',
            name: 'UserEdit',
            component: UserEdit,
            meta: {
                title: '用户信息更新'
            }
        },
        {
            path: '/user/login',
            name: 'UserLogin',
            component: UserLogin,
            meta: {
                title: '用户登录'
            }
        },
        {
            path: '/user/bind',
            name: 'UserBind',
            component: UserBind,
            meta: {
                title: '用户绑定'
            }
        },
        {
            path: '/user/register',
            name: 'UserRegister',
            component: UserRegister,
            meta: {
                title: '用户注册'
            }
        },
        {
            path: '/user/forgetpassword',
            name: 'ForgetPassword',
            component: ForgetPassword,
            meta: {
                title: '忘记密码'
            }
        },
        {
            path: '/user/resetpassword',
            name: 'ResetPassword',
            component: ResetPassword,
            meta: {
                title: '重置密码'
            }
        }
    ]
})